import { Router } from '@angular/router';

/**
 * Route questions the chrome asks in more than one place. The top bar (mobile)
 * and the breadcrumb band (desktop) each render a back button, so the rule for
 * when it appears lives here rather than being copied into both.
 */

/** Path segments of the primary outlet, e.g. ['home', 'administration', 'bre-condition']. */
export function primarySegments(router: Router): string[] {
    const primary = router.parseUrl(router.url || '').root.children['primary'];
    return primary ? primary.segments.map((s) => s.path) : [];
}

/** The dashboard at /home — the root of every trail. */
export function isHomeRoute(router: Router): boolean {
    const segments = primarySegments(router);
    return segments.length === 1 && segments[0] === 'home';
}

/** Hidden on the dashboard and on the workflow landing pages, which have nothing behind them. */
export function canGoBack(router: Router): boolean {
    const segments = primarySegments(router);
    return !(isHomeRoute(router) || segments.includes('idp-application') || segments.includes('idp-doc-grid'));
}

/** These two open in their own tab, so "back" means closing it. */
export function navigateBack(router: Router): void {
    const segments = primarySegments(router);
    const opensInOwnTab = segments[0] === 'home' && segments[1] === 'administration' && (segments[2] === 'bre-condition' || segments[2] === 'e-tracker-view-details');

    if (opensInOwnTab) {
        window.close();
        return;
    }

    window.history.back();
}
